export const ForegroundDark = 'rgba(0, 65, 71, 1)';
export const ForegroundDefault = 'rgba(36, 78, 82, 1)';
export const ForegroundSubtle = 'rgba(111, 111, 111, 1)';
export const ForegroundGhost = 'rgba(141, 141, 141, 1)';
export const ForegroundDisabled = 'rgba(168, 168, 168, 1)';
export const ForegroundLight = 'rgba(255, 255, 255, 1)';
export const ForegroundOnPrimary = 'rgba(255, 255, 255, 1)';
export const ForegroundPrimary = 'rgba(255, 102, 71, 1)';
export const ForegroundPrimaryHover = 'rgba(116, 37, 57, 1)';
export const ForegroundOnSecondary = 'rgba(255, 255, 255, 1)';
export const ForegroundSecondary = 'rgba(57, 57, 57, 1)';
export const ForegroundSecondaryHover = 'rgba(0, 0, 0, 1)';
export const ForegroundOnTertiary = 'rgba(38, 38, 38, 1)';
export const ForegroundOnBooking = 'rgba(255, 255, 255, 1)';
export const ForegroundBooking = 'rgba(255, 102, 71, 1)';
export const ForegroundBookingHover = 'rgba(116, 37, 57, 1)';
export const ForegroundOnDiscountLight = 'rgba(255, 255, 255, 1)';
export const ForegroundOnDiscountDark = 'rgba(210, 74, 6, 1)';
export const ForegroundDiscount = 'rgba(255, 102, 71, 1)';
export const ForegroundDiscountHover = 'rgba(116, 37, 57, 1)';
export const ForegroundOnRating = 'rgba(7, 184, 108, 1)';
export const ForegroundRating = 'rgba(7, 184, 108, 1)';
export const ForegroundSucces = 'rgba(47, 179, 80, 1)';
export const ForegroundInfo = 'rgba(20, 115, 230, 1)';
export const ForegroundWarning = 'rgba(218, 123, 17, 1)';
export const ForegroundAlert = 'rgba(229, 52, 63, 1)';
export const BackgroundDefault = 'rgba(255, 255, 255, 1)';
export const BackgroundTint = 'rgba(249, 247, 245, 1)';
export const BackgroundDark = 'rgba(211, 223, 224, 1)';
export const BackgroundHover = 'rgba(211, 223, 224, 1)';
export const BackgroundDisabled = 'rgba(244, 244, 244, 1)';
export const BackgroundPrimary = 'rgba(255, 102, 71, 1)';
export const BackgroundPrimaryHover = 'rgba(116, 37, 57, 1)';
export const BackgroundPrimarySelected = 'rgba(255, 240, 237, 1)';
export const BackgroundSecondary = 'rgba(57, 57, 57, 1)';
export const BackgroundSecondaryHover = 'rgba(0, 0, 0, 1)';
export const BackgroundSecondarySelected = 'rgba(244, 244, 244, 1)';
export const BackgroundTertiary = 'rgba(255, 255, 255, 1)';
export const BackgroundTertiaryHover = 'rgba(255, 255, 255, 1)';
export const BackgroundTertiarySelected = 'rgba(255, 255, 255, 1)';
export const BackgroundBooking = 'rgba(255, 102, 71, 1)';
export const BackgroundBookingHover = 'rgba(116, 37, 57, 1)';
export const BackgroundBookingSelected = 'rgba(255, 240, 237, 1)';
export const BackgroundDiscountDefault = 'rgba(255, 102, 71, 1)';
export const BackgroundDiscountHover = 'rgba(116, 37, 57, 1)';
export const BackgroundDiscountSelected = 'rgba(255, 240, 237, 1)';
export const BackgroundSucces = 'rgba(47, 179, 80, 1)';
export const BackgroundSuccesLight = 'rgba(47, 179, 80, 0.1)';
export const BackgroundInfo = 'rgba(20, 115, 230, 1)';
export const BackgroundInfoLight = 'rgba(20, 115, 230, 0.1)';
export const BackgroundWarning = 'rgba(218, 123, 17, 1)';
export const BackgroundWarningLight = 'rgba(218, 123, 17, 0.1)';
export const BackgroundAlert = 'rgba(229, 52, 63, 1)';
export const BackgroundAlertLight = 'rgba(229, 52, 63, 0.1)';
export const BackgroundRating = 'rgba(230, 248, 240, 1)';
export const BorderDefault = 'rgba(197, 213, 214, 1)';
export const BorderStrong = 'rgba(141, 168, 168, 1)';
export const BorderPrimary = 'rgba(255, 102, 71, 1)';
export const BorderPrimaryLight = 'rgba(255, 163, 145, 1)';
export const BorderSecondary = 'rgba(57, 57, 57, 1)';
export const BorderSecondaryLight = 'rgba(198, 198, 198, 1)';
export const BorderBooking = 'rgba(255, 102, 71, 1)';
export const BorderBookingLight = 'rgba(255, 163, 145, 1)';
export const BorderDiscountDefault = 'rgba(255, 102, 71, 1)';
export const BorderDiscountLight = 'rgba(255, 240, 237, 1)';
export const BorderSucces = 'rgba(47, 179, 80, 1)';
export const BorderInfo = 'rgba(20, 115, 230, 1)';
export const BorderWarning = 'rgba(218, 123, 17, 1)';
export const BorderAlert = 'rgba(229, 52, 63, 1)';

export const Spacing1 = '4px';
export const Spacing2 = '8px';
export const Spacing3 = '12px';
export const Spacing4 = '16px';
export const Spacing5 = '20px';
export const Spacing6 = '24px';
export const Spacing7 = '28px';
export const Spacing8 = '32px';
export const Spacing9 = '36px';
export const Spacing10 = '40px';
export const Spacing11 = '44px';
export const Spacing12 = '48px';
export const Spacing14 = '56px';
export const Spacing16 = '64px';
export const Spacing20 = '80px';
export const Spacing24 = '96px';
export const Spacing28 = '112px';
export const Spacing32 = '128px';
export const Spacing36 = '144px';
export const Spacing40 = '160px';
export const Spacing44 = '176px';
export const Spacing48 = '192px';
export const Spacing52 = '208px';
export const Spacing56 = '224px';
export const Spacing60 = '240px';
export const Spacing64 = '256px';
export const Spacing72 = '288px';
export const Spacing80 = '320px';
export const Spacing96 = '384px';
export const SpacingPx = '1px';
export const Spacing05 = '2px';
export const Spacing15 = '6px';
export const Spacing25 = '10px';
export const Spacing35 = '14px';
export const BorderRadiusFull = '9999px';
export const BorderRadiusLg = '24px';
export const BorderRadiusBase = '6px';
export const BorderRadiusSm = '3px';
export const SortTagBackgroundDefault = 'rgba(255, 255, 255, 1)';
export const SortTagBackgroundHover = 'rgba(0, 0, 0, 1)';
export const SortTagBackgroundSelected = 'rgba(57, 57, 57, 1)';
export const SortTagBorderDefault = 'rgba(197, 213, 214, 1)';
export const FilterTagBackgroundDefault = 'rgba(244, 244, 244, 1)';
export const FilterTagBackgroundHover = 'rgba(57, 57, 57, 1)';
export const ToggleBackgroundDefault = 'rgba(244, 244, 244, 1)';
export const DateHitCountButtonBackgroundDefault = 'rgba(244, 244, 244, 1)';
export const DateHitCountButtonBackgroundHover = 'rgba(244, 244, 244, 1)';
export const DateHitCountButtonBackgroundActive = 'rgba(57, 57, 57, 1)';
export const DateHitCountButtonBorderHover = 'rgba(57, 57, 57, 1)';
export const CalenderCellForegroundOnLight = 'rgba(38, 38, 38, 1)';
export const CalenderCellForegroundOnDark = 'rgba(255, 255, 255, 1)';
export const CalenderCellForegroundAccent = 'rgba(7, 184, 108, 1)';
export const CalenderCellBackgroundDefault = 'rgba(255, 255, 255, 1)';
export const CalenderCellBackgroundAvailable = 'rgba(230, 248, 240, 1)';
export const CalenderCellBackgroundRange = 'rgba(230, 248, 240, 1)';
export const CalenderCellBackgroundSelected = 'rgba(7, 184, 108, 1)';
export const CalenderCellBorderDefault = 'rgba(7, 184, 108, 1)';
export const CalenderCellBorderLight = 'rgba(230, 248, 240, 1)';
